export default {
  name: 'productTags',
  component({ tagConfig = '', configuredTags = '', maxTags = 3, initialTags = [], showSaleBadge = false, saleBadgeText = 'Sale', hideSaleBadgeTag = '', initialCompareAtPrice = 0, initialPrice = 0 } = {}) {
    return {
      tagConfig,
      configuredTags,
      maxTags,
      tags: initialTags,
      showSaleBadge,
      saleBadgeText,
      hideSaleBadgeTag,
      compareAtPrice: initialCompareAtPrice,
      price: initialPrice,

      init() {
        const tile = this.$el.closest('[x-product-tile-init]');
        if (tile) {
          tile.addEventListener('tile:swap-product', (e) => {
            this.tags = e.detail?.tags || [];
            this.compareAtPrice = e.detail?.compare_at_price ?? 0;
            this.price = e.detail?.price ?? 0;
          });
        }
      },

      get normalizedTags() {
        const rawTags = this.tags;
        return Array.isArray(rawTags)
          ? rawTags
          : (rawTags ? String(rawTags).split(',').map(t => t.trim()).filter(Boolean) : []);
      },

      get hasSaleSuppressingTag() {
        if (!this.hideSaleBadgeTag) return false;
        const target = this.hideSaleBadgeTag.trim().toLowerCase();
        return this.normalizedTags.some(tag => tag.trim().toLowerCase() === target);
      },

      get isSale() {
        return this.showSaleBadge && this.compareAtPrice > 0 && this.compareAtPrice > this.price && !this.hasSaleSuppressingTag;
      },

      get displayTags() {
        const productTags = this.normalizedTags;
        const configured = this.configuredTags ? this.configuredTags.split(',').map(t => t.trim()).filter(Boolean) : [];

        if (!configured.length) return [];

        // Build name → display map from tagConfig (format: "name:display|name:display")
        const configMap = {};
        if (this.tagConfig) {
          this.tagConfig.split('|').forEach(pair => {
            const colonIndex = pair.indexOf(':');
            if (colonIndex === -1) return;
            const name = pair.slice(0, colonIndex).trim();
            const display = pair.slice(colonIndex + 1).trim();
            configMap[name] = display;
          });
        }

        const slotsUsed = this.isSale ? 1 : 0;
        return configured
          .filter(name => productTags.includes(name))
          .slice(0, Math.max(0, this.maxTags - slotsUsed))
          .map(name => ({ name, display: configMap[name] || name }));
      }
    };
  }
};
